import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import router from './router'


Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(VueRouter);

Vue.config.productionTip = false;

//注意 这个项目其实不需要 移动传输数据
axios.defaults.baseURL = 'https://sjpc2.zzhuifu.cn/';//多余的


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
